import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import i18n from '../../../../../i18n';
import DeploymentBar from '../../../MockServices/DeploymentBar/DeploymentBar';
import { MockService } from '../../../../../types/rest/mockServiceTypes';
import _ from 'lodash';
import { calculateStageDurations, convertStagesToArray } from '../../../MockServices/DeploymentBar/DeploymentBarsUtils';
import { Alert } from 'react-bootstrap';
import BzmIcon from '../../../../../components/icons/BzmIcon';

interface DeploymentInfoModalProps {
  onHide: () => void;
  mockService: MockService;
}

export interface DeploymentStages {
  starting?: number;
  waitingForDomain?: number;
  startingContainer?: number;
  containerReady?: number;
  generatingData?: number;
  indexingData?: number;
  stopping?: number;
}

export interface DeploymentResult {
  durations: DeploymentStages;
  totalDuration: number; // Total duration in seconds
}

const DeploymentInfoModal = ({ onHide, mockService }: DeploymentInfoModalProps) => {
  const stagesArray = convertStagesToArray(mockService.metadata.stages);
  let stageDurations: DeploymentResult;
  if (!_.isNil(stagesArray)) {
    //Sort by timestamp
    stagesArray.sort((d1, d2) => new Date(d1.dateTime).getTime() - new Date(d2.dateTime).getTime());
    stageDurations = calculateStageDurations(stagesArray);
  }

  return (
    <Modal show={true} centered={true} backdrop={true} onHide={onHide} size={'lg'}>
      <Modal.Header closeButton>
        <h5 className="modal-title">Deployment Timing Overview</h5>
      </Modal.Header>
      <Modal.Body>
        <p>
          The Deployment Timing Overview provides a detailed breakdown of the time taken by each phase during the
          virtual service container deployment process.
        </p>
        {!_.isNil(stageDurations) && _.get(stageDurations, 'totalDuration', 0) !== 0 ? (
          <DeploymentBar stages={stageDurations.durations} />
        ) : (
          <Alert variant={'info'}>
            <BzmIcon variant={'icon-bzm-info'} className={'alert-icon'} />
            <p className={'alert-message mb-0'}>No Deployment Timing Overview available</p>
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onHide}>
          {i18n.t('common:actions.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeploymentInfoModal;
